import { render, staticRenderFns } from "./RouterTabItem.vue?vue&type=template&id=03046953"
import script from "./RouterTabItem.vue?vue&type=script&lang=ts"
export * from "./RouterTabItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports